type AuthTokenProvider = () => Promise<string | null>;

let provider: AuthTokenProvider | null = null;

// Registered from App (inside Auth0Provider) so the non-React API layer can
// obtain a valid token per request instead of a login-time snapshot.
export const setAuthTokenProvider = (fn: AuthTokenProvider | null) => {
  provider = fn;
};

// Returns a valid ID token, silently renewing through the Auth0 SDK when
// expired. Falls back to the last token persisted in localStorage (provider
// not registered yet, mock auth in tests).
export const getAuthToken = async (): Promise<string | null> => {
  if (provider) {
    try {
      const token = await provider();
      if (token) {
        return token;
      }
    } catch {
      // SDK could not renew (e.g. not authenticated yet) — fall back below;
      // the 401 interceptor handles genuinely expired sessions.
    }
  }
  return window.localStorage.getItem('userToken');
};
